import { cn } from '@/lib/cn'
import { initials } from '@/lib/format'

interface Props {
  name?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZES: Record<NonNullable<Props['size']>, string> = {
  sm: 'w-7 h-7 text-[11px]',
  md: 'w-9 h-9 text-xs',
  lg: 'w-12 h-12 text-sm',
}

export function Avatar({ name, size = 'md', className }: Props) {
  return (
    <div className={cn(
      'flex items-center justify-center rounded-full bg-brand-100 text-brand-700 font-semibold',
      SIZES[size],
      className,
    )}>
      {initials(name)}
    </div>
  )
}
